import apis from "../../../utils/apis";
import { showFeedbackModal } from "../UserFeedbackActions";
import { handleApiError } from "../utils/utils";

export const sendExternalCollaboratorInvite =
  (values: { Email: string; Matter: string; Permission: string }) =>
  async (dispatch: any) => {
    try {
      const payload = {
        email: values.Email,
        matter: values.Matter,
        permission: values.Permission,
      };

      const response = await apis.post("external/collaborator/send_invite", payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response && response.status >= 200 && response.status < 300) {
        dispatch(
            showFeedbackModal({
              modalType: 'success',
              message: response.data.message || 'External Collaborator invited successfully.',
              showModal: true,
              duration: 3000,
            })
          );
        return response.data;
      } else {
        handleApiError(response, dispatch);
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };


  export const inviteExternalCollaborator =
  (values: any) =>
  async (dispatch: any) => {

    try {
      const response = await apis.post(
        "/external/collaborator/invite",
        values,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response && response.status >= 200 && response.status < 300) {
        dispatch(
            showFeedbackModal({
              modalType: 'success',
              message: response.data.message || 'External Collaborator invited successfully.',
              showModal: true,
              duration: 3000,
            })
          );
        return response.data;
      } else {
        handleApiError(response, dispatch);
       
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };


  export const fetchExternalCollaboratorDetails =
  (externalId: string | number) =>
  async (dispatch: any) => {

    try {
      const response = await apis.post(
        "/external/collaborator/details",
        { CollaboratorID: externalId },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response && response.status >= 200 && response.status < 300) {
        const details = response.data?.CollaboratorDetails ?? response.data;
        dispatch(
            showFeedbackModal({
              modalType: 'success',
              message: response.data.message || 'External Collaborator details fetched successfully.',
              showModal: true,
              duration: 3000,
            })
          );
        return details; 
      } else {
        handleApiError(response, dispatch);
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };


  export const revokeCaseInvitation =
  (id: string | number) =>
  async (dispatch: any) => {
    try {
      const res = await apis.post(
        "/cases/invitations/revoke",
        { id },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res && res.status >= 200 && res.status < 300) {
        dispatch(
            showFeedbackModal({
              modalType: 'success',
              message: res.data.message || 'Case access revoked.',
              showModal: true,
              duration: 3000,
            })
          );
        return res.data ?? true;
      } else {
        handleApiError(res, dispatch);
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };


export const deleteCaseCollaborator =
  (id: string | number) =>
  async (dispatch: any) => {
    try {
      const res = await apis.delete(`/cases/collaborators/${id}`);

      if (res && res.status >= 200 && res.status < 300) {
        dispatch(
            showFeedbackModal({
              modalType: 'success',
              message: res.data.message || 'External Collaborator deleted successfully.',
              showModal: true,
              duration: 3000,
            })
          );
        return res.data ?? true;
      } else {
        handleApiError(res, dispatch);
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };


export const resendExternalCollaboratorInvite =
  (id: string | number) =>
  async (dispatch: any) => {
    try {
      const res = await apis.post(
        "/external/collaborator/invitation/resend",
        { ExternalID: id },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res && res.status >= 200 && res.status < 300) {
        dispatch(
            showFeedbackModal({
              modalType: 'success',
              message: res.data.message || 'Invitation sent successfully.',
              showModal: true,
              duration: 3000,
            })
          );
        return res.data ?? true;
      } else {
        handleApiError(res, dispatch);
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };